import { useCallback } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { setErrorMessages } from 'components/ErrorMessageHandler/slice';
import { useAppDispatch } from 'store/hooks';

export const useErrorHandler = (
  descriptor: MessageDescriptor
): (() => void) => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  return useCallback(() => {
    dispatch(setErrorMessages([intl.formatMessage(descriptor)]));
  }, [descriptor, dispatch, intl]);
};
